import { plansOrder } from "../helpers/plans"
import getLegacyPlanName from "../services/getLegacyPlanName"

function usePlans() {
  const getDiscountMap = plan => {
    const priceToPay =
      plan.price.net_amount -
      Math.abs(parseFloat(plan.discount.price.net_amount))

    return {
      ...plan.discount,
      priceToPay,
      isFree: priceToPay <= 0,
    }
  }

  const getLegacyPlan = subscribedPlans =>
    subscribedPlans.data
      ? subscribedPlans.data.data.plans.find(subscription =>
          getLegacyPlanName(subscription.plan_name.toLowerCase())
        )
      : null

  const getFreeTier = freeTier => {
    if (!freeTier) return null

    return {
      savingsAmount: freeTier.savings_amount,
      freeOfFeeAmount: freeTier.free_of_fee_amount,
    }
  }

  const groupPlans = plansResponseData =>
    plansResponseData.reduce(
      (acc, current) => {
        if (current.type === "domestic") {
          return { ...acc, domesticPlans: [...acc?.domesticPlans, current] }
        }

        if (
          current.type === "international" &&
          current.subscription_period === "year"
        ) {
          return { ...acc, yearlyPlans: [...acc?.yearlyPlans, current] }
        }

        if (
          current.type === "international" &&
          current.subscription_period === "month"
        ) {
          return { ...acc, monthlyPlans: [...acc?.monthlyPlans, current] }
        }

        return acc
      },
      {
        monthlyPlans: [],
        yearlyPlans: [],
        domesticPlans: [],
      }
    )

  const sortPlans = ({ monthlyPlans, yearlyPlans, domesticPlans }) => {
    const sortByOrder = (plans, orderArr) =>
      plans.sort(
        (planA, planB) =>
          orderArr.indexOf(planA.name) - orderArr.indexOf(planB.name)
      )

    return {
      monthlyPlans: sortByOrder(monthlyPlans, plansOrder.monthly),
      yearlyPlans: sortByOrder(yearlyPlans, plansOrder.yearly),
      domesticPlans: sortByOrder(domesticPlans, plansOrder.domestic),
    }
  }

  const getPlans = response => {
    const newPlans = response.data
      ? response.data?.data?.plans.map(plan => ({
          ...plan,
          displayName: plan.name.split(" - ")[0],
          isDiscountApplied: !!plan.discount,
          discount: plan.discount ? getDiscountMap(plan) : null,
          freeTier: getFreeTier(plan.free_tier),
        }))
      : []

    const groupedPlans = groupPlans(newPlans)
    const sortedPlans = sortPlans(groupedPlans)

    return {
      minimum_monthly_charge: response.data?.data?.minimum_monthly_charge,
      shipping_active_commission_discount:
        response.data?.shipping_active_commission_discount || "",
      ...sortedPlans,
    }
  }
  return {
    getPlans,
    getLegacyPlan,
  }
}

export default usePlans
